var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStraight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 21.9723C17.9225 21.5888 22 17.2706 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.2706 6.07745 21.5888 11.25 21.9723V10.8107L8.53033 13.5303C8.23744 13.8232 7.76256 13.8232 7.46967 13.5303C7.17678 13.2374 7.17678 12.7626 7.46967 12.4697L11.4697 8.46967C11.6103 8.32902 11.8011 8.25 12 8.25C12.1989 8.25 12.3897 8.32902 12.5303 8.46967L16.5302 12.4695C16.8231 12.7624 16.8231 13.2373 16.5302 13.5302C16.2373 13.8231 15.7624 13.8231 15.4695 13.5302L12.75 10.8107V21.9723Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraight);
export default __webpack_public_path__ + "static/media/straight.4598c366ffe1b0b928f0a53a6146fa7f.svg";
export { ForwardRef as ReactComponent };